var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulatoryLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 300,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 20021 20021",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10604 588v864c-184-79-385-123-593-123-209 0-410 44-593 123v-864c0-784 1186-784 1186 0zm4953 2607h-4527c-151 417-550 716-1019 716-470 0-869-299-1020-716h-4527l2125 6319h263c0 1400-1318 2535-2944 2535-1627 0-2945-1135-2945-2535h263l2372-7055h5393c151-417 550-715 1020-715 469 0 868 298 1019 715h5393l2373 7055h262c0 1400-1318 2535-2944 2535s-2945-1135-2945-2535h263zm-1437 6319h3987l-1993-5928zm-12206 0h3987l-1993-5928zm8097-7116c237 0 429 192 429 429s-192 430-429 430c-238 0-430-193-430-430s192-429 430-429zm593 1805v9535l1512 511v806c-1403 0-2807 0-4211 0v-806l1513-511v-9535c183 79 384 122 593 122 208 0 409-43 593-122z",
    fill: "#80828a",
    fillOpacity: 1,
    "data-original-color": "#333333ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_959666400",
    fill: "#04599c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1486 15055h18535v938h-18317c-508 0-924 416-924 925v1240c0 509 416 925 924 925h18317v938h-18535c-817 0-1486-668-1486-1486v-1994c0-817 669-1486 1486-1486z",
    fill: "#80828a",
    fillOpacity: 1,
    "data-original-color": "#04599cff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1892 16351h17777c-533 876-496 1662 0 2374h-17777c-460 0-737-249-737-710v-954c0-447 248-710 737-710z",
    fill: "#80828a",
    fillOpacity: 1,
    "data-original-color": "#04599cff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "boxes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20021v20021h-20021z",
    fill: "none",
    fillOpacity: 1,
    stroke: "none",
    strokeOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatoryLogo2);
export default __webpack_public_path__ + "static/media/regulatory-logo-2.a8a7ef4c3adbbf5378ec561dbb8439c3.svg";
export { ForwardRef as ReactComponent };